import React, { useState, useEffect } from "react";
import { Pagination, TextField, MenuItem, Box, Button } from "@mui/material";
import { useSetPaginationStateChange } from "scripts/util";

const PaginationComponent = ({ totalItems, defaultPageSize }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize || 10);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const { onPageChange, onPageSizeChange, onHandleDateRangeFilter } =
    useSetPaginationStateChange();

  const totalPages = Math.ceil(totalItems / pageSize);

  useEffect(() => {
    onPageChange(currentPage);
  }, [currentPage]);

  useEffect(() => {
    onPageSizeChange(pageSize);
  }, [pageSize]);

  const handlePageChange = (event, page) => {
    setCurrentPage(page - 1); // Pagination starts from 0 in the backend
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
  };

  const handleDateRangeChange = () => {
    onHandleDateRangeFilter(fromDate, toDate);
  };
  console.log(totalPages, currentPage, totalItems, pageSize);
  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      {/* Date Range Filter */}
      {/* <Box display="flex" gap={2}>
        <TextField
          label="From Date"
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="To Date"
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <button onClick={handleDateRangeChange}>Filter</button>
      </Box> */}

      {/* Pagination with Previous and Next Buttons */}
      <Box display="flex" gap={2} alignItems="center">
        {/* Page Size Selector */}
        <TextField
          select
          label="Page Size"
          value={pageSize}
          onChange={handlePageSizeChange}
        >
          {[1, 2, 3, 4, 5].map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </TextField>
        <Button
          sx={{
            backgroundColor: "orange",
          }}
          variant="contained"
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 0} // Disable "Prev" if on first page
        >
          Prev
        </Button>

        <Pagination
          count={totalPages}
          page={currentPage + 1}
          onChange={handlePageChange}
          color="standard"
        />

        <Button
          sx={{
            backgroundColor: "orange",
          }}
          variant="contained"
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage + 1 === totalPages} // Disable "Next" if on last page
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default PaginationComponent;
